import React from 'react';
import { Handle, Position } from '@xyflow/react';

function SubnetNode({ data, selected }) {
  return (
    <div
      className={`relative rounded border-2 border-dashed p-2 transition-colors ${
        selected ? 'border-teal-500 bg-teal-50/70 dark:bg-teal-900/30' : 'border-teal-300 bg-teal-50/40 dark:bg-teal-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-teal-500" />
      <div className="flex items-center gap-1.5">
        <svg
          className="h-3.5 w-3.5 text-teal-600 dark:text-teal-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <rect x="2" y="7" width="20" height="14" rx="2" />
          <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
        </svg>
        <span className="text-xs font-semibold text-teal-900 dark:text-teal-100">{data.name}</span>
      </div>
      {data.cidr && (
        <span className="mt-1 inline-block bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.cidr}
        </span>
      )}
      <div className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">Subnet</div>
      <Handle type="source" position={Position.Bottom} className="!bg-teal-500" />
    </div>
  );
}

export default SubnetNode;
